import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSelectors } from '@states/auth/auth.selectors';

/**
 * Already Host Guard
 *
 * Prevents users who already have an organization from accessing the become-a-host flow.
 * Redirects them to their host dashboard instead.
 */
export const alreadyHostGuard = () => {
  const store = inject(Store);
  const router = inject(Router);

  const user = store.selectSnapshot(AuthSelectors.getUser);

  // If user has an organization, redirect to host dashboard
  if (user?.organizationId) {
    console.log('[AlreadyHostGuard] User already has organization, redirecting to dashboard');
    return router.createUrlTree(['/host-dashboard']);
  }

  // Allow access to become-a-host
  return true;
};
